import {Injectable} from "@angular/core";
import {HttpService} from "../../_service/http.service";
import {PagesHelper} from "../../shared-module/pagination/pages-helper";
import {Notification} from "../notifications-part/notification.model";
import {ProblemRequestDto} from "./request-model/problem-request-dto.model";
import {ProblemType} from "./request-model/problem-type.model";
import {Porch} from "./request-model/porch.model";
import {Floor} from "./request-model/floor.model";
import {WebResult} from "../../shared-module/models/web-result";

enum ErrorTokens {
    NULL_OR_EMPTY_DATA = "NULL_OR_EMPTY_DATA",
    NOT_FOUND = "NOT_FOUND",
    PROBLEM_NOT_DONE_YET = "Problem request is not DONE yet!",
    NULL_OR_EMPTY_PROBLEM_TYPE = "NULL_OR_EMPTY_PROBLEM_TYPE",
    NULL_OR_EMPTY_FLOOR = "NULL_OR_EMPTY_FLOOR",
    NULL_OR_EMPTY_PORCH = "NULL_OR_EMPTY_PORCH",
    NULL_OR_EMPTY_PHONE = "NULL_OR_EMPTY_PHONE",
    NULL_OR_EMPTY_DESIRED_DATETIME = "NULL_OR_EMPTY_DESIRED_DATETIME",
    PROBLEM_REQUEST_LIMIT_EXCEED = "PROBLEM_REQUEST_LIMIT_EXCEED",
    FILES_ERROR = "FILES_ERROR",
    CLOSED_ACCOUNT = "CLOSED_ACCOUNT",
}

@Injectable()
export class RequestService {
    private getData;


    constructor(private httpService: HttpService) {
    }


    async getProblemRequests(realtyId: number, currentPage: number, pageSize: number, blockId?: string):
        Promise<PagesHelper<ProblemRequestDto>> {

        const offset = (currentPage - 1) * pageSize < 0 ? 0 : (currentPage - 1) * pageSize;
        const sb = [];
        sb.push('rest/');
        sb.push('getProblemRequests?');
        sb.push('realtyId=');
        sb.push(realtyId);
        sb.push('&offset=');
        sb.push(offset);
        sb.push('&limit=');
        sb.push(pageSize);

        await this.httpService.getDataWithLocalAuth(sb.join(''), blockId)
            .then((data: PagesHelper<any>) => {
                this.getData = new PagesHelper<Notification>(data);
            });
        return this.getData;
    }


    async getProblemRequest(requestId: string):
        Promise<ProblemRequestDto> {

        const sb = [];
        sb.push('rest/');
        sb.push('getProblemRequest?');
        sb.push('id=');
        sb.push(requestId);

        await this.httpService.getDataWithLocalAuth(sb.join(''))
            .then((data: ProblemRequestDto) => {
                this.getData = data;
            });

        return this.getData;
    }


    async getProblemTypes(blockId?: string): Promise<Array<ProblemType>> {

        const sb = [];
        sb.push('rest/');
        sb.push('getProblemTypes');

        return await this.httpService.getDataWithLocalAuth(sb.join(''), blockId)
            .then((data) => {
                return data;
            });
    }


    async getClosestDates(blockId?: string): Promise<Array<string>> {

        const sb = [];
        sb.push('rest/');
        sb.push('getClosestDates');

        return await this.httpService.getDataWithLocalAuth(sb.join(''), blockId)
            .then((data) => {
                return data;
            });
    }


    async getPorches(realtyId: number, blockId?: string): Promise<Array<Porch>> {

        const sb = [];
        sb.push('rest/');
        sb.push('getPorches?');
        sb.push('realtyId=');
        sb.push(realtyId);

        return await this.httpService.getDataWithLocalAuth(sb.join(''), blockId)
            .then((data) => {
                return data;
            });
    }


    async getFloors(realtyId: number, porchId: string, blockId?: string): Promise<Array<Floor>> {

        const sb = [];
        sb.push('rest/');
        sb.push('getFloors?');
        sb.push('realtyId=');
        sb.push(realtyId);
        sb.push('&porchId=');
        sb.push(porchId);

        return await this.httpService.getDataWithLocalAuth(sb.join(''), blockId)
            .then((data) => {
                return data;
            });
    }


    async post(appeal: any, blockId?: string) {

        const sb = [];
        sb.push('rest/site/');
        sb.push('createRequest?');

        await this.httpService.postDataWithAuth(sb.join(''), appeal, blockId)
            .then((data) => {
                console.log('createRequest: ', data);
            }, (error) => {
                let errorToken: WebResult = JSON.parse(error._body);
                throw this.getErrorMessage(errorToken);
            });
    }


    async postProblemRequest(filesAndRequest: FormData, blockId?: string) {

        const sb = [];
        sb.push('file-rest/');
        sb.push('postProblemRequest?');

        await this.httpService.postFilesDataWithAuth(sb.join(''), filesAndRequest, blockId)
            .then((data) => {
                console.log('createRequest: ', data);
            }, (error) => {
                console.log("Error problemRequest");
                let errorToken: WebResult;
                if (error.status == 400) {
                    errorToken = JSON.parse(error._body);
                }
                throw this.getErrorMessage(errorToken);
            });
    }


    private getErrorMessage(errorToken: WebResult | undefined): WebResult {
        if (errorToken == null) {
            return new WebResult("Что-то пошло не так", false);
        }
        if (errorToken.messageToken == ErrorTokens.NULL_OR_EMPTY_DATA) {
            return new WebResult("Проверьте, пожалуйста, все ли поля заполнены.", errorToken.isSuccess);
        }
        if (errorToken.messageToken == ErrorTokens.NULL_OR_EMPTY_PROBLEM_TYPE) {
            return new WebResult("Укажите неисправность.", errorToken.isSuccess);
        }
        if (errorToken.messageToken == ErrorTokens.NULL_OR_EMPTY_FLOOR) {
            return new WebResult("Укажите этаж.", errorToken.isSuccess);
        }
        if (errorToken.messageToken == ErrorTokens.NULL_OR_EMPTY_PORCH) {
            return new WebResult("Укажите подъезд.", errorToken.isSuccess);
        }
        if (errorToken.messageToken == ErrorTokens.NULL_OR_EMPTY_PHONE) {
            return new WebResult("Укажите номер телефона", errorToken.isSuccess);
        }
        if (errorToken.messageToken == ErrorTokens.NULL_OR_EMPTY_DESIRED_DATETIME) {
            return new WebResult("Укажите время прихода мастера.", errorToken.isSuccess);
        }
        if (errorToken.messageToken == ErrorTokens.PROBLEM_REQUEST_LIMIT_EXCEED) {
            return new WebResult("Заявка не может быть отправлена сейчас. Повторите попытку позднее.", errorToken.isSuccess);
        }
        if (errorToken.messageToken == ErrorTokens.FILES_ERROR) {
            return new WebResult("Не удалось сохранить файл.", errorToken.isSuccess);
        }
        if (errorToken.messageToken == ErrorTokens.CLOSED_ACCOUNT) {
            return new WebResult("Заявка не может быть привязана к закрытому лицевому счету",
                errorToken.isSuccess);
        }
        if (errorToken.messageToken == ErrorTokens.PROBLEM_NOT_DONE_YET) {
            return new WebResult("Работы по заявке еще не завершены",
                errorToken.isSuccess);
        }
        if (errorToken.messageToken == ErrorTokens.NOT_FOUND) {
            return new WebResult("Не удалось оставить отзыв",
                errorToken.isSuccess);
        }

        return new WebResult("Что-то пошло не так", false);
    }


    async rateProblemRequest(request: ProblemRequestDto, blockId?: string): Promise<WebResult>{

        const sb = [];
        sb.push('rest/');
        sb.push('rateProblemRequest?');
        sb.push('verCommonId=' + request.id);
        sb.push('&rating=' + request.rating);
        sb.push('&comment=' + request.ratingComment);
        sb.push('&confirmationToken=' + request.isConfirmedByUser);

       return await this.httpService.postDataWithAuth(sb.join(''), blockId)
            .then((data) => {
                return data;
            }, (error) => {
                console.log("Error problemRequest");
                let errorToken: WebResult;
                if (error.status == 400) {
                    errorToken = JSON.parse(error._body);
                }
                throw this.getErrorMessage(errorToken);
            });
    }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/main-page/request-part/request.service.ts